module.exports = __webpack_public_path__ + "img/PTT.a9bf07ec.png";